import { h } from 'vue'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

/**
 * roles: [USER: 代理商本人, ADMINISTRATOR: 内部员工, SITE: 代理商客户(权限最小)]
 */

const g = (name) => {
  return h(
    'svg',
    { class: 'svg-icon xn-icon' },
    h('use', { href: `#icon-${name}` })
  )
}

export const baseRouterList: any = [
  {
    path: '/',
    name: 'home',
    meta: { hideInMenu: true },
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: 'login', hideInMenu: true },
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/404',
    meta: { title: '404', hideInMenu: true },
    component: () => import('@/views/error/404.vue')
  },
]

export const routerList: any = [
  {
    path: '/domainCertCdn',
    name: 'domainCertCdn',
    meta: { title: '域名/证书/CDN', icon: g('cdn') },
    children: [
      {
        path: 'bindDomain',
        name: 'bindDomain',
        meta: { title: '绑定域名' },
        component: () => import('@/views/domainCertCdn/bindDomain/index.vue')
      },
      {
        path: 'cdn',
        name: 'cdn',
        meta: { title: '网站加速 CDN' },
        component: () => import('@/views/domainCertCdn/cdn/index.vue')
      },
    ]
  },
  {
    path: '/fileManage',
    name: 'fileManage',
    meta: { title: '文件管理', icon: g('file') },
    // target: process.env.VUE_APP_API + '/api/vhost/jumpFileManage',
    component: () => import('@/views/fileManage/index.vue')
  },
  {
    path: '/database/manage',
    name: 'databaseManage',
    meta: { title: '数据库管理', icon: g('db') },
    component: () => import('@/views/database/manage/index.vue')
  },
  {
    path: '/hostEnvSet',
    name: 'hostEnvSet',
    meta: { title: '主机环境设置', icon: g('hostEnv') },
    redirect: { name: 'hostEnvSetHome' },
    children: [
      {
        path: 'home',
        name: 'hostEnvSetHome',
        meta: { title: '设置网站首页' },
        component: () => import('@/views/hostEnvSet/home.vue')
      },
      {
        path: 'pseudoStatic',
        name: 'hostEnvSetPseudoStatic',
        meta: { title: '伪静态管理' },
        component: () => import('@/views/hostEnvSet/pseudoStatic.vue')
      },
      {
        path: '301',
        name: 'hostEnvSet301',
        meta: { title: '域名 301 重定向' },
        component: () => import('@/views/hostEnvSet/301/index.vue')
      },
      {
        path: '404',
        name: 'hostEnvSet404',
        meta: { title: '设置 404 错误页' },
        component: () => import('@/views/hostEnvSet/404/index.vue')
      },
      {
        path: 'errorInfo',
        name: 'hostEnvSetErrorInfo',
        meta: { title: '设置脚本错误信息' },
        component: () => import('@/views/hostEnvSet/errorInfo.vue')
      },
      {
        path: 'mime',
        name: 'hostEnvSetMime',
        meta: { title: 'MIME 映射' },
        component: () => import('@/views/hostEnvSet/mime/index.vue')
      },
      {
        path: 'php',
        name: 'hostEnvSetPhp',
        meta: { title: 'PHP 管理' },
        component: () => import('@/views/hostEnvSet/php.vue')
      },
      {
        path: 'dNet',
        name: 'hostEnvSetDNet',
        meta: { title: '.NET 管理' },
        component: () => import('@/views/hostEnvSet/dNet.vue')
      },
      // {
      //   path: 'os',
      //   name: 'hostEnvSetOS',
      //   meta: { title: '变更操作系统' },
      //   component: () => import('@/views/hostEnvSet/os.vue')
      // }
    ]
  },
  {
    path: '/backup',
    name: 'backup',
    meta: { title: '备份与恢复', icon: g('backup') },
    children: [
      {
        path: 'site',
        name: 'backupSite',
        meta: { title: '网站备份与恢复' },
        component: () => import('@/views/backup/site/index.vue')
      },
      {
        path: 'database',
        name: 'backupDatabase',
        meta: { title: '数据库备份' },
        component: () => import('@/views/backup/database/index.vue')
      },
    ]
  },
  {
    path: '/tool',
    name: 'tool',
    meta: { title: '工具', icon: g('tool') },
    children: [
      {
        path: 'siteMigrate',
        name: 'siteMigrate',
        meta: { title: '网站搬家' },
        component: () => import('@/views/tool/siteMigrate/index.vue')
      },
      {
        path: 'siteImage',
        name: 'siteImage',
        meta: { title: '站点镜像' },
        component: () => import('@/views/tool/siteImage/index.vue')
      },
      // {
      //   path: 'installProgram',
      //   name: 'installProgram',
      //   meta: { title: '安装 WordPress' },
      //   component: () => import('@/views/tool/installProgram/index.vue')
      // },
      // Independent mirror
      {
        path: 'plugInManager',
        name: 'plugInManager',
        meta: { title: '应用管理' },
        component: () => import('@/views/tool/plugInManager/index.vue')
      },
    ]
  },
  {
    path: '/safe',
    name: 'safe',
    meta: { title: '安全防护', icon: g('safe') },
    children: [
      {
        path: 'fileTamperProof',
        name: 'fileTamperProof',
        meta: { title: '文件防篡改' },
        component: () => import('@/views/safe/fileTamperProof/index.vue')
      },
      {
        path: 'searchAndKill',
        name: 'searchAndKill',
        meta: { title: '挂马查杀' },
        component: () => import('@/views/safe/searchAndKill/index.vue')
      },
    ]
  },
  // {
  //   path: '/service',
  //   name: 'service',
  //   meta: { title: '人工服务', roles: ['USER', 'ADMINISTRATOR'], icon: g('service') },
  //   component: () => import('@/views/error/404.vue')
  // },
  {
    path: '/taskCenter',
    name: 'taskCenter',
    meta: { title: '任务中心', icon: g('file_task') },
    component: () => import('@/views/taskCenter/index.vue')
  },
  {
    path: '/hostingConversion',
    name: 'hostingConversion',
    meta: { title: '迁移记录', icon: g('file_task') },
    component: () => import('@/views/hostingConversion/index.vue')
  },
  {
    path: '/log',
    name: 'log',
    meta: { title: '操作日志', icon: g('log') },
    component: () => import('@/views/log/index.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    meta: { hideInMenu: true }
  }
]

const routes: Array<RouteRecordRaw> = [
  ...baseRouterList,
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
